<ion-header *ngIf="!device.isMobile()">
  <ion-toolbar>
    <ion-title>{{ "PUZZLE.settings_modal.title" | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="puzzle-modal-grow">
    <ion-col>
      <ion-list>

        <ng-container *ngIf="isCrosswordGame">
          <ion-item lines="none">
            <ion-text color="primary">
              <h2>{{ 'PUZZLE.settings_modal.sections.general.title' | translate }}</h2>
            </ion-text>
          </ion-item>
          <ion-item lines="inset" *ngIf="!framework.isZoomDisabled()">
            <ion-toggle color="primary" [checked]="autoZoomEnabled" (ionChange)="setAutoZoom($event)">
              <ion-label class="ion-text-wrap">
                <b>{{ 'PUZZLE.button_bar.buttons.auto_zoom.help.title' | translate }}</b>
                <p>{{ 'PUZZLE.button_bar.buttons.auto_zoom.help.text' | translate }}</p>
                <p class="default-indicator">
                  [{{ 'PUZZLE.settings_modal.default.label' | translate }}
                  : {{ ('PUZZLE.settings_modal.default.' + (framework.autoZoomDefaultBasedOnDevice() ? 'on' : 'off'))|translate }}
                  ]
                </p>
              </ion-label>
            </ion-toggle>
          </ion-item>
          <ion-item lines="inset" *ngIf="framework.allowUserToggleDefinitionBar">
            <ion-toggle color="primary" [checked]="definitionBarEnabled" (ionChange)="setDefinitionBarEnabled($event)">
              <ion-label class="ion-text-wrap">
                <b>{{ 'PUZZLE.button_bar.buttons.definition_bar.help.title' | translate }}</b>
                <p>{{ 'PUZZLE.button_bar.buttons.definition_bar.help.text' | translate }}</p>
                <p class="default-indicator">
                  [{{ 'PUZZLE.settings_modal.default.label' | translate }}
                  : {{ ('PUZZLE.settings_modal.default.' + (framework.definitionBarEnabledDefaultBasedOnDevice() ? 'on' : 'off'))|translate }}
                  ]
                </p>
              </ion-label>
            </ion-toggle>
          </ion-item>
          <ion-item
            lines="inset"
            *ngIf="framework.puzzleFrameworkConfig.keepKeyboardOpenAllowUserChange && helperFunctions.isMobileDevice() && framework.hasKeyboardInput"
          >
            <ion-toggle color="primary" [checked]="keepKeyboardOpen" (ionChange)="setKeepKeyboardOpen($event)">
              <ion-label class="ion-text-wrap">
                <b>{{ 'PUZZLE.button_bar.buttons.keep_keyboard_open.title' | translate }}</b>
                <p>{{ 'PUZZLE.button_bar.buttons.keep_keyboard_open.help.text' | translate }}</p>
                <p class="default-indicator">
                  [{{ 'PUZZLE.settings_modal.default.label' | translate }}
                  : {{ 'PUZZLE.settings_modal.default.off' | translate }}
                  ]
                </p>
              </ion-label>
            </ion-toggle>
          </ion-item>

          <ion-item lines="inset">
            <ion-toggle
              color="primary" [(ngModel)]="highlightRightAndWrongEnabled"
              (ionChange)="setHighlightRightAndWrongEnabled($event)"
            >
              <ion-label class="ion-text-wrap">
                <b>{{ 'PUZZLE.button_bar.buttons.highlight_right_and_wrong.title' | translate }}</b>
                <p>{{ 'PUZZLE.button_bar.buttons.highlight_right_and_wrong.help.text' | translate }}</p>
                <p class="default-indicator">
                  [{{ 'PUZZLE.settings_modal.default.label' | translate }}
                  : {{ ('PUZZLE.settings_modal.default.' + (framework.puzzleFrameworkConfig.highlightRightAndWrongEnabledDefault ? 'on' : 'off'))|translate }}
                  ]
                </p>
                <p *ngIf="leaderboard.leaderboardEnabled$ | async" class="default-indicator">
                  [{{ 'PUZZLE.settings_modal.leaderboard_default.label' | translate }}
                  : {{ ('PUZZLE.settings_modal.leaderboard_default.off') | translate }}]
                </p>
              </ion-label>
            </ion-toggle>
          </ion-item>

          <!-- JUMPING WORDS -->
          <ng-container *ngIf="!isCrossword221">
            <ion-item lines="none">
              <ion-text color="primary" slot="start">
                <h2>{{ 'PUZZLE.settings_modal.sections.word_jump.title' | translate }}</h2>
              </ion-text>
            </ion-item>

            <ion-radio-group [(ngModel)]="wordJumpOnRestriction" (ionChange)="changeWordJumpOnRestriction($event)">
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">
                  <b>{{ 'PUZZLE.settings_modal.sections.word_jump.on.title' | translate }}</b>
                  <p>{{ 'PUZZLE.settings_modal.sections.word_jump.on.text' | translate }}</p>
                </ion-label>
              </ion-item>
              <ion-item
                *ngFor="let value of wordJumpOnRestrictionValues; let last = last"
                [lines]="last ? 'inset' : 'none'"
                [class.ion-margin-bottom]="last"
                style="--min-height: 1em"
              >
                <ion-radio [value]="value" justify="space-between" labelPlacement="start">
                  <ion-label class="ion-text-wrap">
                    {{ 'PUZZLE.settings_modal.sections.word_jump.on.values.' + value | translate }}
                    <span class="default-indicator"
                          *ngIf="value === WordJumpOnRestrictions.CorrectWord && framework.wordJumpOnDefaultBasedOnDevice() || value === WordJumpOnRestrictions.None && !framework.wordJumpOnDefaultBasedOnDevice()">
                    [{{ 'PUZZLE.settings_modal.default.label' | translate }}]
                  </span>
                    <span
                      class="default-indicator"
                      *ngIf="(leaderboard.leaderboardEnabled$ | async) && value === WordJumpOnRestrictions.CompleteWord && framework.wordJumpOnDefaultBasedOnDevice()"
                    >
                    [{{ 'PUZZLE.settings_modal.leaderboard_default.label' | translate }}]
                  </span>
                  </ion-label>
                </ion-radio>
              </ion-item>
            </ion-radio-group>

            <ion-radio-group [(ngModel)]="wordJumpToRestriction" (ionChange)="changeWordJumpToRestriction($event)">
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">
                  <b>{{ 'PUZZLE.settings_modal.sections.word_jump.to.title' | translate }}</b>
                  <p>{{ 'PUZZLE.settings_modal.sections.word_jump.to.text' | translate }}</p>
                </ion-label>
              </ion-item>
              <ion-item
                *ngFor="let value of wordJumpToRestrictionValues; let last = last"
                [lines]="last ? 'inset' : 'none'" [class.ion-margin-bottom]="last" style="--min-height: 1em"
              >
                <ion-radio [value]="value" justify="space-between" labelPlacement="start">
                  <ion-label class="ion-text-wrap">
                    {{ 'PUZZLE.settings_modal.sections.word_jump.to.values.' + value | translate }}
                    <span class="default-indicator" *ngIf="value === WordJumpToRestrictions.IncorrectWord">
                    [{{ 'PUZZLE.settings_modal.default.label' | translate }}]
                  </span>
                    <span
                      class="default-indicator"
                      *ngIf="(leaderboard.leaderboardEnabled$ | async) && value === WordJumpToRestrictions.IncompleteWord"
                    >
                    [{{ 'PUZZLE.settings_modal.leaderboard_default.label' | translate }}]
                  </span>
                  </ion-label>
                </ion-radio>
              </ion-item>
            </ion-radio-group>
          </ng-container>

          <ion-item lines="none">
            <ion-text color="primary" slot="start">
              <h2>{{ 'PUZZLE.settings_modal.sections.letter_skipping.title' | translate }}</h2>
            </ion-text>
          </ion-item>

          <ion-radio-group
            [(ngModel)]="letterOverwriteRestriction"
            (ionChange)="changeLetterOverwriteRestriction($event)"
          >
            <ion-item lines="none">
              <ion-label class="ion-text-wrap">
                <b>{{ 'PUZZLE.settings_modal.sections.letter_skipping.overwrite.title' | translate }}</b>
                <p>{{ 'PUZZLE.settings_modal.sections.letter_skipping.overwrite.text' | translate }}</p>
              </ion-label>
            </ion-item>
            <ion-item
              *ngFor="let value of letterOverwriteRestrictionValues; let last = last"
              [lines]="last ? 'inset' : 'none'" [class.ion-margin-bottom]="last" style="--min-height: 1em"
            >
              <ion-radio [value]="value" justify="space-between" labelPlacement="start">
                <ion-label class="ion-text-wrap">
                  {{ 'PUZZLE.settings_modal.sections.letter_skipping.overwrite.values.' + value | translate }}
                  <span
                    class="default-indicator"
                    *ngIf="value === LetterOverwriteRestrictions.None"
                  >
                    [{{ 'PUZZLE.settings_modal.default.label' | translate }}]
                  </span>
                  <span
                    class="default-indicator"
                    *ngIf="(leaderboard.leaderboardEnabled$ | async) && value === LetterOverwriteRestrictions.None"
                  >
                    [{{ 'PUZZLE.settings_modal.leaderboard_default.label' | translate }}]
                  </span>
                </ion-label>
              </ion-radio>
            </ion-item>
          </ion-radio-group>

          <ion-radio-group [(ngModel)]="letterDeleteRestriction" (ionChange)="changeLetterDeleteRestriction($event)">
            <ion-item lines="none">
              <ion-label class="ion-text-wrap">
                <b>{{ 'PUZZLE.settings_modal.sections.letter_skipping.delete.title' | translate }}</b>
                <p>{{ 'PUZZLE.settings_modal.sections.letter_skipping.delete.text' | translate }}</p>
              </ion-label>
            </ion-item>
            <ion-item
              *ngFor="let value of letterDeleteRestrictionValues; let last = last"
              [lines]="last ? 'inset' : 'none'" style="--min-height: 1em"
            >
              <ion-radio [value]="value" justify="space-between" labelPlacement="start">
                <ion-label class="ion-text-wrap">
                  {{ 'PUZZLE.settings_modal.sections.letter_skipping.delete.values.' + value | translate }}
                  <span
                    class="default-indicator"
                    *ngIf="(leaderboard.leaderboardEnabled$ | async) && value === LetterDeleteRestrictions.CompletedWords">
                    <br />
                    [{{ 'PUZZLE.settings_modal.leaderboard_default.label'|translate }}]
                  </span>
                  <span
                    class="default-indicator"
                    *ngIf="value === LetterDeleteRestrictions.CorrectWords"
                  >
                    [{{ 'PUZZLE.settings_modal.default.label'|translate }}]
                  </span>
                </ion-label>
              </ion-radio>
            </ion-item>
          </ion-radio-group>
        </ng-container>

        <ng-container *ngIf="isSudokuGame">

          <ion-item lines="inset">
            <ion-toggle
              color="primary" [(ngModel)]="showErrorsImmediately"
              (ionChange)="setShowErrorsImmediately($event)"
            >
              <ion-label class="ion-text-wrap">
                <b>{{ 'PUZZLE.button_bar.buttons.show_errors_immediately.title' | translate }}</b>
                <p>{{ 'PUZZLE.button_bar.buttons.show_errors_immediately.help.text' | translate }}</p>
                <p class="default-indicator">
                  [{{ 'PUZZLE.settings_modal.default.label' | translate }}
                  : {{ ('PUZZLE.settings_modal.default.' + (framework.puzzleFrameworkConfig.showErrorsImmediatelyEnabledDefault ? 'on' : 'off'))|translate }}
                  ]
                </p>
              </ion-label>
            </ion-toggle>
          </ion-item>

        </ng-container>

        <ng-container *ngIf="isHashiGame">

          <ion-item lines="inset">
            <ion-toggle
              color="primary" [(ngModel)]="showErrorsImmediately"
              (ionChange)="setShowErrorsImmediately($event)"
            >
              <ion-label class="ion-text-wrap">
                <b>{{ 'PUZZLE.button_bar.buttons.show_errors_immediately.title' | translate }}</b>
                <p>{{ 'PUZZLE.button_bar.buttons.show_errors_immediately.help.text' | translate }}</p>
                <p class="default-indicator">
                  [{{ 'PUZZLE.settings_modal.default.label' | translate }}
                  : {{ ('PUZZLE.settings_modal.default.' + (framework.puzzleFrameworkConfig.showErrorsImmediatelyEnabledDefault ? 'on' : 'off'))|translate }}
                  ]
                </p>
              </ion-label>
            </ion-toggle>
          </ion-item>

        </ng-container>

        <ion-item lines="none">
          <ion-text color="primary">
            <h2>{{ 'PUZZLE.settings_modal.sections.appearance.title' | translate }}</h2>
          </ion-text>
        </ion-item>

        <ion-radio-group [(ngModel)]="darkMode" (ionChange)="changeDarkMode($event)">
          <ion-item lines="none">
            <ion-label class="ion-text-wrap">
              <b>{{ 'PUZZLE.settings_modal.sections.appearance.dark_mode.title' | translate }}</b>
              <p>{{ 'PUZZLE.settings_modal.sections.appearance.dark_mode.text' | translate }}</p>
            </ion-label>
          </ion-item>
          <ion-item
            *ngFor="let value of darkModeValues; let last = last" [lines]="last ? 'inset' : 'none'"
            style="--min-height: 1em"
          >
            <ion-radio [value]="value" justify="space-between" labelPlacement="start">
              <ion-label class="ion-text-wrap">
                {{ 'PUZZLE.settings_modal.sections.appearance.dark_mode.values.' + value | translate }}
                <span
                  class="default-indicator"
                  *ngIf="value === DarkModes.System"
                >
                  [{{ 'PUZZLE.settings_modal.default.label'|translate }}]
                </span>
              </ion-label>
            </ion-radio>
          </ion-item>
        </ion-radio-group>

        <ion-item lines="inset">
          <ion-toggle color="primary" [checked]="highContrastEnabled" (ionChange)="setHighContrastEnabled($event)">
            <ion-label class="ion-text-wrap">
              <b>{{ 'PUZZLE.button_bar.buttons.high_contrast.help.title' | translate }}</b>
              <p>{{ 'PUZZLE.button_bar.buttons.high_contrast.help.text' | translate }}</p>
              <p class="default-indicator">
                [{{ 'PUZZLE.settings_modal.default.label' | translate }}
                : {{ ('PUZZLE.settings_modal.default.off')|translate }}]
              </p>
            </ion-label>
          </ion-toggle>
        </ion-item>


        <ion-item lines="none" />

      </ion-list>

    </ion-col>

  </ion-grid>
</ion-content>


<ion-footer>
  <div class="puzzle-modal-buttons">
    <ion-button
      size="small"
      color="primary"
      fill="clear"
      slot="start"
      (click)="closeDialog(true)"
    >
      {{ 'PUZZLE.settings_modal.buttons.reset' | translate }}
    </ion-button>
    <ion-button
      color="primary"
      (click)="closeDialog(false)" fill="solid"
    >
      {{ "PUZZLE.settings_modal.buttons.done" | translate }}
    </ion-button>
  </div>
</ion-footer>
